import { useState } from "react";
import ApiService from "./ApiService";
import { Encrypt } from "./../../helpers/security/LSEA";
import configLoader from './../../helpers/configs/ConfigLoader';

function ApiHandler() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleGetApi = (url, payload) => {
        if (payload) {
            ApiService.setPayload(configLoader.get("API_REQUEST_CHANNEL_KEY"), Encrypt(Encrypt(JSON.stringify(payload.load))));
            ApiService.setPayload(configLoader.get("API_REQUEST_TOKEN_KEY"), payload.apiToken);
        }

        setLoading(true);
        ApiService.get(url)
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false));
    };

    const handlePostApi = (url, payload) => {
        if (payload) {
            ApiService.setPayload(configLoader.get("API_REQUEST_CHANNEL_KEY"), Encrypt(Encrypt(JSON.stringify(payload.load))));
            ApiService.setPayload(configLoader.get("API_REQUEST_TOKEN_KEY"), payload.apiToken);
        }

        setLoading(true);
        ApiService.post(url)
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false));
    };

    const handlePutApi = (url, payload) => {
        if (payload) {
            ApiService.setPayload(configLoader.get("API_REQUEST_CHANNEL_KEY"), Encrypt(Encrypt(JSON.stringify(payload.load))));
            ApiService.setPayload(configLoader.get("API_REQUEST_TOKEN_KEY"), payload.apiToken);
        }

        setLoading(true);
        ApiService.put(url)
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false));
    };

    const handleDeleteApi = (url, payload) => {
        if (payload) {
            ApiService.setPayload(configLoader.get("API_REQUEST_CHANNEL_KEY"), Encrypt(Encrypt(JSON.stringify(payload.load))));
            ApiService.setPayload(configLoader.get("API_REQUEST_TOKEN_KEY"), payload.apiToken);
        }

        setLoading(true);
        ApiService.delete(url)
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false));
    };

    return { data, loading, error, handleGetApi, handlePostApi, handlePutApi, handleDeleteApi };
}

export default ApiHandler;
